import { createContext } from "react";
export const TranslateContext = createContext({
    locale: "zh-CN",
    setLocale: (x) => Promise.resolve(),
});
// import chinese from "./china";
// import english from "./english";
// import React, {useContext, useState} from "react";
// export const LocaleContext = React.createContext({
//     locale : "chinese",
//     toggleLocale    : _ => _
// });
// const translate = language => (msg, replace = {}) => {
//     const languages = {
//         chinese     : chinese,
//         english     : english
//     }
//     let result = languages[language];
//     try{
//         const keys = msg.split('.').filter(x => x);
//         for(let key of keys){
//             result = result[key]
//         }
//     } catch(e){
//         result = msg;
//     }
//     for(let key in replace){
//         result = result.replace("${"+key+"}", replace[key]);
//     }
//     return result;
// }
// export default Component => props => {
//     const {locale, toggleLocale} = useContext(LocaleContext);
//     return <Component translate={translate(locale)} toggleLocale={toggleLocale} locale={locale} {...props}/>
// }
// export const LocaleProvider = (props) => {
//     const {locale : defaultLocale} = props;
//     const [locale, toggleLocale] = useState(defaultLocale);
//     return (
//         <LocaleContext.Provider value={{
//             locale,
//             toggleLocale
//         }}>
//             {props.children}
//         </LocaleContext.Provider>
//     )
// }
